import * as React from "react";
import Tippy, { TippyProps } from "@tippyjs/react";

export type ITooltipProps = TippyProps;

export function Tooltip({ children, ...props }: ITooltipProps): JSX.Element {
    return <Tippy {...props}>{children}</Tippy>;
}
